module.exports = __webpack_public_path__ + "img/jp-01.1949a3e6.jpg";